import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { RiAdminFill } from "react-icons/ri";
import { MdAddAlert } from "react-icons/md";
import { TiContacts } from "react-icons/ti";
import { CgWebsite } from "react-icons/cg";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { PatentContext } from "../../../../context/PatentContextProvider";

const Sidenav = () => {
  const navigate = useNavigate();
  function handleLogout() {
    localStorage.removeItem("token");
    navigate("/login", { state: { isLoggedOut: true } });
  }
  const { activeLink, handleLinkClick, role } = useContext(PatentContext);

  return (
    <div className="h-[96%]  w-52 bg-gray-800 pt-20 pb-4 text-white flex flex-col justify-between fixed rounded-lg">
      <>
        <div>
          {role !== "user" ? (
            <>
              <nav className="flex flex-col">
                <NavLink
                  to="/allpages"
                  onClick={() => handleLinkClick("/allpages")}
                  className={`px-3 py-2 hover:bg-gray-700 rounded  inline-flex gap-2  items-center z-50 ${
                    activeLink === "/allpages" ? "bg-gray-700" : ""
                  }`}
                >
                  <RiAdminFill />
                  CMS
                </NavLink>
                <NavLink
                  to="/alerts"
                  onClick={() => handleLinkClick("/alerts")}
                  className={`px-3 py-2 hover:bg-gray-700 rounded  inline-flex gap-2  items-center z-50 ${
                    activeLink === "/alerts" ? "bg-gray-700" : ""
                  }`}
                >
                  <MdAddAlert />
                  Alert System
                </NavLink>
                <NavLink
                  to="/contact-requests"
                  onClick={() => handleLinkClick("/contact-requests")}
                  className={`px-3 py-2 hover:bg-gray-700 rounded  inline-flex gap-2  items-center z-50 ${
                    activeLink === "/contact-requests" ? "bg-gray-700" : ""
                  }`}
                >
                  <TiContacts />
                  Contact Requests
                </NavLink>
                <NavLink
                  to="/tracking"
                  onClick={() => handleLinkClick("/tracking")}
                  className={`px-3 py-2 hover:bg-gray-700 rounded  inline-flex gap-2  items-center z-50 ${
                    activeLink === "/tracking" ? "bg-gray-700" : ""
                  }`}
                >
                  <CgWebsite />
                  Website Tracking
                </NavLink>
              </nav>
              <NavLink
                to="/infringments"
                onClick={() => handleLinkClick("/infringments")}
                className={`px-3 py-2 hover:bg-gray-700 rounded  flex gap-2  items-center z-50 ${
                  activeLink === "/infringments" ? "bg-gray-700" : ""
                }`}
              >
                <svg
                  class="w-4 h-4"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.9057 5.68009L5.68009 16.9057C4.62644 15.5506 4 13.8491 4 12C4 7.58172 7.58172 4 12 4C13.8491 4 15.5506 4.62644 16.9057 5.68009ZM7.0943 18.3199L18.3199 7.0943C19.3736 8.44939 20 10.1509 20 12C20 16.4183 16.4183 20 12 20C10.1509 20 8.44939 19.3736 7.0943 18.3199ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5223 6.47771 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47771 17.5223 2 12 2Z"></path>
                </svg>
                Violations
              </NavLink>
              <NavLink
                to="/requested-infringements"
                onClick={() => handleLinkClick("/requested-infringements")}
                className={`px-3 py-2 hover:bg-gray-700 rounded  flex gap-2  items-center z-50 ${
                  activeLink === "/requested-infringements" ? "bg-gray-700" : ""
                }`}
              >
                <svg
                  class="w-4 h-4"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.9057 5.68009L5.68009 16.9057C4.62644 15.5506 4 13.8491 4 12C4 7.58172 7.58172 4 12 4C13.8491 4 15.5506 4.62644 16.9057 5.68009ZM7.0943 18.3199L18.3199 7.0943C19.3736 8.44939 20 10.1509 20 12C20 16.4183 16.4183 20 12 20C10.1509 20 8.44939 19.3736 7.0943 18.3199ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5223 6.47771 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47771 17.5223 2 12 2Z"></path>
                </svg>
                Requested Violations
              </NavLink>
              <NavLink
                to="/chats"
              className={`px-3 py-2 hover:bg-gray-700 rounded flex gap-2 items-center z-50 ${activeLink === "/chats" ? "bg-gray-700" : ""}`}>
                <IoChatbubbleEllipsesOutline  style={{fontSize: "18px"}}/>
                Ask jeeves
              </NavLink>
              {/* <NavLink
                to="/companies"
                onClick={() => handleLinkClick("/companies")}
                className={`px-3 py-2 hover:bg-gray-700 rounded flex gap-2 items-center z-50 ${
                  activeLink === "/companies" ? "bg-gray-700" : ""
                }`}
              >
                <svg
                  class="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <path fill="currentColor" d="M8 0l-8 3v2h16v-2z"></path>
                  <path fill="currentColor" d="M0 14h16v2h-16v-2z"></path>
                  <path
                    fill="currentColor"
                    d="M16 7v-1h-16v1h1v5h-1v1h16v-1h-1v-5h1zM4 12h-1v-5h1v5zM7 12h-1v-5h1v5zM10 12h-1v-5h1v5zM13 12h-1v-5h1v5z"
                  ></path>
                </svg>
                Companies
              </NavLink>
              <NavLink
                to="/attorneys"
                onClick={() => handleLinkClick("/attorneys")}
                className={`px-3 py-2 hover:bg-gray-700 rounded flex gap-2 items-center z-50 ${
                  activeLink === "/attorneys" ? "bg-gray-700" : ""
                }`}
              >
                <svg
                  class="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <path d="M14.63 7L13 3h1V2H9V1H8v1H3v1h1L2.38 7H2v1h.15c.156.498.473.93.9 1.23a2.47 2.47 0 0 0 2.9 0A2.44 2.44 0 0 0 6.86 8H7V7h-.45L4.88 3H8v8H6l-.39.18-2 2.51.39.81h9l.39-.81-2-2.51L11 11H9V3h3.13l-1.67 4H10v1h.15a2.48 2.48 0 0 0 4.71 0H15V7h-.37zM5.22 8.51a1.52 1.52 0 0 1-.72.19 1.45 1.45 0 0 1-.71-.19A1.47 1.47 0 0 1 3.25 8h2.5a1.52 1.52 0 0 1-.53.51zM5.47 7h-2l1-2.4 1 2.4zm5.29 5L12 13.5H5L6.24 12h4.52zm1.78-7.38l1 2.4h-2l1-2.4zm.68 3.91a1.41 1.41 0 0 1-.72.19 1.35 1.35 0 0 1-.71-.19 1.55 1.55 0 0 1-.54-.53h2.5a1.37 1.37 0 0 1-.53.53z"></path>
                </svg>
                Attorneys
              </NavLink>
              <NavLink
                to="/litigators"
                onClick={() => handleLinkClick("/add-litigator")}
                className={`px-3 py-2 hover:bg-gray-700 rounded flex gap-2 items-center z-50 ${
                  activeLink === "/litigators" ? "bg-gray-700" : ""
                }`}
              >
                <svg
                  class="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <path d="M14.63 7L13 3h1V2H9V1H8v1H3v1h1L2.38 7H2v1h.15c.156.498.473.93.9 1.23a2.47 2.47 0 0 0 2.9 0A2.44 2.44 0 0 0 6.86 8H7V7h-.45L4.88 3H8v8H6l-.39.18-2 2.51.39.81h9l.39-.81-2-2.51L11 11H9V3h3.13l-1.67 4H10v1h.15a2.48 2.48 0 0 0 4.71 0H15V7h-.37zM5.22 8.51a1.52 1.52 0 0 1-.72.19 1.45 1.45 0 0 1-.71-.19A1.47 1.47 0 0 1 3.25 8h2.5a1.52 1.52 0 0 1-.53.51zM5.47 7h-2l1-2.4 1 2.4zm5.29 5L12 13.5H5L6.24 12h4.52zm1.78-7.38l1 2.4h-2l1-2.4zm.68 3.91a1.41 1.41 0 0 1-.72.19 1.35 1.35 0 0 1-.71-.19 1.55 1.55 0 0 1-.54-.53h2.5a1.37 1.37 0 0 1-.53.53z"></path>
                </svg>
                Litigators
              </NavLink> */}
            </>
          ) : (
            <>
              {/* <NavLink
                to="/companies"
                onClick={() => handleLinkClick("/companies")}
                className={`px-3 py-2 hover:bg-gray-700 rounded flex gap-2 items-center z-50 ${
                  activeLink === "/companies" ? "bg-gray-700" : ""
                }`}
              >
                <svg
                  class="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <path fill="currentColor" d="M8 0l-8 3v2h16v-2z"></path>
                  <path fill="currentColor" d="M0 14h16v2h-16v-2z"></path>
                  <path
                    fill="currentColor"
                    d="M16 7v-1h-16v1h1v5h-1v1h16v-1h-1v-5h1zM4 12h-1v-5h1v5zM7 12h-1v-5h1v5zM10 12h-1v-5h1v5zM13 12h-1v-5h1v5z"
                  ></path>
                </svg>
                Companies
              </NavLink>
              <NavLink
                to="/attorneys"
                onClick={() => handleLinkClick("/attorneys")}
                className={`px-3 py-2 hover:bg-gray-700 rounded flex gap-2 items-center z-50 ${
                  activeLink === "/attorneys" ? "bg-gray-700" : ""
                }`}
              >
                <svg
                  class="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <path d="M14.63 7L13 3h1V2H9V1H8v1H3v1h1L2.38 7H2v1h.15c.156.498.473.93.9 1.23a2.47 2.47 0 0 0 2.9 0A2.44 2.44 0 0 0 6.86 8H7V7h-.45L4.88 3H8v8H6l-.39.18-2 2.51.39.81h9l.39-.81-2-2.51L11 11H9V3h3.13l-1.67 4H10v1h.15a2.48 2.48 0 0 0 4.71 0H15V7h-.37zM5.22 8.51a1.52 1.52 0 0 1-.72.19 1.45 1.45 0 0 1-.71-.19A1.47 1.47 0 0 1 3.25 8h2.5a1.52 1.52 0 0 1-.53.51zM5.47 7h-2l1-2.4 1 2.4zm5.29 5L12 13.5H5L6.24 12h4.52zm1.78-7.38l1 2.4h-2l1-2.4zm.68 3.91a1.41 1.41 0 0 1-.72.19 1.35 1.35 0 0 1-.71-.19 1.55 1.55 0 0 1-.54-.53h2.5a1.37 1.37 0 0 1-.53.53z"></path>
                </svg>
                Attorneys
              </NavLink>
              <NavLink
                to="/litigators"
                onClick={() => handleLinkClick("/litigators")}
                className={`px-3 py-2 hover:bg-gray-700 rounded flex gap-2 items-center z-50 ${
                  activeLink === "/litigators" ? "bg-gray-700" : ""
                }`}
              >
                <svg
                  class="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <path d="M14.63 7L13 3h1V2H9V1H8v1H3v1h1L2.38 7H2v1h.15c.156.498.473.93.9 1.23a2.47 2.47 0 0 0 2.9 0A2.44 2.44 0 0 0 6.86 8H7V7h-.45L4.88 3H8v8H6l-.39.18-2 2.51.39.81h9l.39-.81-2-2.51L11 11H9V3h3.13l-1.67 4H10v1h.15a2.48 2.48 0 0 0 4.71 0H15V7h-.37zM5.22 8.51a1.52 1.52 0 0 1-.72.19 1.45 1.45 0 0 1-.71-.19A1.47 1.47 0 0 1 3.25 8h2.5a1.52 1.52 0 0 1-.53.51zM5.47 7h-2l1-2.4 1 2.4zm5.29 5L12 13.5H5L6.24 12h4.52zm1.78-7.38l1 2.4h-2l1-2.4zm.68 3.91a1.41 1.41 0 0 1-.72.19 1.35 1.35 0 0 1-.71-.19 1.55 1.55 0 0 1-.54-.53h2.5a1.37 1.37 0 0 1-.53.53z"></path>
                </svg>
                Litigators
              </NavLink> */}
            </>
          )}
        </div>
      </>
      <div className="mb-4 px-4">
        <button
          className="w-full py-2 bg-gray-500 hover:bg-gray-600 rounded text-white font-bold"
          onClick={() => {
            handleLogout();
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidenav;
